import CircularProgress from '@mui/material/CircularProgress';
import './Loader.scss';

const Loader = () => {
    return (
        <div className="Loader">
            <CircularProgress size={60} />
        </div>
    );
};

export default Loader;